interface MediaItems {
  title: string;
  content: string[];
  link: string;
  ariaLabel: string;
}

export const mediaItems: MediaItems[] = [
  {
    title: 'media-1.title',
    content: ['media-1.content'],
    link: 'Human Capital Resilience Charter_250701_132205.pdf',
    ariaLabel: 'media-1.ariaLabel',
  },
  {
    title: 'media-2.title',
    content: ['media-2.content'],
    link: 'Human Capital Resilience Charter Presentation Eng.pdf',
    ariaLabel: 'media-2.ariaLabel',
  },
  {
    title: 'media-3.title',
    content: ['media-3.content'],
    link: 'HCR_Charter_A4_11_eng_pryntsypy_250701_132247.pdf',
    ariaLabel: 'media-3.ariaLabel',
  },
];

export const mediaItemsUa: MediaItems[] = [
  {
    title: 'media-1.title',
    content: ['media-1.content'],
    link: 'Хартія стійкості людського капіталу_250701_132152.pdf',
    ariaLabel: 'media-1.ariaLabel',
  },
  {
    title: 'media-2.title',
    content: ['media-2.content'],
    link: 'Human Capital Resilience Charter Presentation Ukr-1.pdf',
    ariaLabel: 'media-2.ariaLabel',
  },
  {
    title: 'media-3.title',
    content: ['media-3.content'],
    link: 'HCR_Charter_A4_11_ukr_pryntsypy_250701_132300.pdf',
    ariaLabel: 'media-3.ariaLabel',
  },
];
